import React, { useEffect, useRef, useState } from "react";
import { Star } from "lucide-react";

export default function AverageRatingSection() {
  const [rating, setRating] = useState(0);
  const [customers, setCustomers] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  const ratingTarget = 9.6;
  const customersTarget = 10000;

  useEffect(() => {
    const handleScroll = () => {
      if (hasAnimated || !sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const inView = rect.top <= window.innerHeight * 0.75;

      if (inView) {
        setHasAnimated(true);

        const ratingInterval = setInterval(() => {
          setRating((prev) => {
            if (prev >= ratingTarget) {
              clearInterval(ratingInterval);
              return ratingTarget;
            }
            return +(prev + 0.2).toFixed(1);
          });
        }, 50);

        const customerInterval = setInterval(() => {
          setCustomers((prev) => {
            if (prev >= customersTarget) {
              clearInterval(customerInterval);
              return customersTarget;
            }
            return prev + 400;
          });
        }, 20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasAnimated]);

  return (
    <section
      ref={sectionRef}
      className="bg-[#0e1a10] py-20 px-6 text-white text-center font-manrope"
    >
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col items-center gap-6">
          {hasAnimated ? (
            <>
              <h2 className="text-7xl md:text-8xl font-extrabold text-green-400 tracking-tight flex items-center gap-4">
                {rating.toFixed(1)}
                <span className="text-4xl md:text-5xl text-white">/10</span>
                <Star size={50} className="text-green-400 fill-green-400" />
              </h2>

              <p className="text-xl md:text-2xl text-gray-300">
                Trusted by{" "}
                <span className="text-green-400 font-bold">
                  {customers.toLocaleString()}+
                </span>{" "}
                happy users worldwide
              </p>

              <div className="mt-8 h-[4px] w-32 mx-auto bg-gradient-to-r from-green-400 via-lime-400 to-green-500 rounded-full shadow-lg" />
            </>
          ) : (
            <>
              
              <div className="w-60 h-[70px] md:h-[90px] bg-gray-700 animate-pulse rounded-lg" />

              
              <div className="w-80 h-6 bg-gray-700 animate-pulse rounded-md mt-2" />
              <div className="w-64 h-6 bg-gray-600 animate-pulse rounded-md" />

              
              <div className="mt-8 h-[4px] w-32 mx-auto bg-gray-700 animate-pulse rounded-full" />
            </>
          )}
        </div>
      </div>
    </section>
  );
}
